import { FormGroup } from '@angular/forms';
export const messages = [
  { error: 'invalidRut', message: 'Rut inválido' },
  { error: 'emptyRut', message: 'Debes ingresar tu rut para solicitar clave.' },
  { error: 'required', message: 'Campo requerido' },
  { error: 'validPhone', message: 'Formato inválido. Debe tener 9 dígitos' },
  { error: 'mismatchPass', message: 'Contraseña no coincide' },
  { error: 'email', message: 'Formato inválido. Debe ser correo@sitio.com' },
  { error: 'minlength', message: 'El mínimo debe ser minlength caracteres' },
  { error: 'maxlength', message: 'El máximo debe ser maxlength caracteres' },
  {
    error: 'aplphanumeric',
    message: 'Debe contener letras y números',
  },
];

export const getErrorMessage = (form: FormGroup, field: string): string => {
  const control = form.get(field);
  if (!control) {
    return;
  }

  if (!control || control.valid) {
    return;
  }

  if (!control.errors) {
    return;
  }

  const keyErrors = Object.keys(control.errors);
  const message = messages.find(m => m.error === keyErrors[0]);
  if (!message) {
    return '';
  }
  if (message.error === 'maxlength') {
    message.message = message.message.replace(
      'maxlength',
      control.errors.maxlength.requiredLength
    );
  }

  if (message.error === 'minlength') {
    message.message = message.message.replace(
      'minlength',
      control.errors.minlength.requiredLength
    );
  }
  return message.message;
};
